import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import nds from '@nerdwallet/base-styles/classes';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  boolCheckboxSpec,
  stringInputSpec,
  stringSelectSpec,
} from '../../lib/editing-configs';

import './audio-embed.less';

const AudioEmbed = ({
  autoPlay,
  audioSlug,
  color,
  selectHeight,
  selectWidth,
  showUser,
  size,
}) => {
  const autoPlayParam = autoPlay ? '&auto_play=true' : '&auto_play=false';
  const playerColor = `&color=${color}`;
  const playerColorParam = color ? playerColor : '';
  const showTeaserParam = '&show_teaser=true';
  const showVisualParam = '&visual=true';
  const showCommentsParam = '&show_comments=false';
  const showRepostsParam = '&show_reposts=false';
  const showUserParam = showUser ? '&show_user=true' : '&show_user=false';
  const widthParam = size === 'sm' ? '100%' : `${selectWidth}`;
  const audioUrl = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${audioSlug}${autoPlayParam}${playerColorParam}${showTeaserParam}${showVisualParam}${showCommentsParam}${showRepostsParam}${showUserParam}`;

  return (
    <div
      className={classNames([
        'audio-embed__cont',
        nds('position-relative'),
        nds('margin-vertical-5'),
        nds('margin-horizontal-auto'),
        nds('text-align-center'),
      ])}
    >
      <iframe
        title="audio embed"
        id="audio"
        className={classNames([
          'audio-embed__iframe',
          nds('margin-horizontal-auto'),
        ])}
        width={widthParam}
        height={selectHeight}
        src={audioUrl}
        frameBorder="no"
        scrolling="no"
        allow="autoplay"
      />
    </div>
  );
};

AudioEmbed.propTypes = {
  autoPlay: PropTypes.bool,
  audioSlug: PropTypes.string,
  color: PropTypes.string,
  selectHeight: PropTypes.string,
  selectWidth: PropTypes.string,
  showUser: PropTypes.bool,
  size: PropTypes.string,
};

AudioEmbed.defaultProps = {
  audioSlug: '',
  color: '',
  selectHeight: '300',
};

AudioEmbed.getEditingConfig = () => [
  stringInputSpec('audioSlug', 'Audio Slug', {
    help: 'The Audio Slug is the string of numerals that immediately follows the XXXXXX portion of the Share URL generated by SoundCloud',
  }),
  stringSelectSpec(
    'selectHeight',
    'Select height of player',
    [
      { label: '300px', value: '300' },
      { label: '450px', value: '450' },
      { label: '600px', value: '600' },
    ],
    {
      help: 'You may select one of three default heights for the player: 300px, 450px, or 600px',
    }
  ),
  stringInputSpec(
    'selectWidth',
    'Input custom width of player (non-mobile screen sizes only)',
    {
      help: 'You may input a custom width for the player (in pixels) for desktop-only. On mobile screen sizes, width will default to 100%.',
    }
  ),
  stringInputSpec('color', 'Play Button Color', {
    help: 'Color play button and other controls. e.g. "0066CC"',
  }),
  boolCheckboxSpec('autoPlay', 'Auto play audio?', {
    help: 'When checked, player starts playing the item automatically',
  }),
  boolCheckboxSpec('showUser', 'Show User', {
    help: 'Show/Hide the uploader name',
  }),
];

AudioEmbed.displayName = 'AudioEmbed';

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
  })
)(AudioEmbed);
